import React from 'react';

import { PrimaryButton, SecondaryButton, ButtonsBlock } from '../Ui';
import FAQ from '../faq';

export default function Confirmation(props) {
	const { estimateNumber, user } = props;
	const estimateLink =
		'https://www.legallais.com/user/estimate?realtime=' + estimateNumber;
	return (
		<div className="confirmation__wrapper">
			<div className="confirmation__banner" />
			<div className="confirmation__dialog-wrapper">
				<div className="dialog-container">
					<div className="card card-confirmation">
						<div className="dialog__avatar-wrapper">
							<img
								src={require('../../assets/circle-avatar.png')}
							/>
						</div>
						<h1 className="dialog__title">Bravo !</h1>
						<p className="dialog__text-1">
							Plus qu'une étape pour finaliser votre organigramme
						</p>
						{__COM__ ? (
							<p className="dialog__text-2">
								Le devis n°
								{estimateNumber} pour l'organigramme de{' '}
								{user.civility} {user.firstname} {user.lastname}{' '}
								est désormais disponible dans son espace pro sur
								legallais.com, rubrique Devis Express.
							</p>
						) : (
							<p className="dialog__text-2">
								Le devis n°
								{estimateNumber} pour votre organigramme est
								désormais disponible dans votre espace pro sur
								legallais.com, rubrique Devis Express.
							</p>
						)}
						<div className="dialog__actions">
							<a className="mr-1" href={props.planLink}>
								<SecondaryButton>
									Télécharger mon plan
								</SecondaryButton>
							</a>
							{!__COM__ && (
								<a href={estimateLink} target="_blank">
									<PrimaryButton>
										Voir mon devis
									</PrimaryButton>
								</a>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/js/confirmation/Confirmation.js